export default __webpack_public_path__ + "static/media/ddsu5168-4.925c75f0.png";